import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { createInquiry, type CreateInquiryRequest } from '../services/inquiries';
import type { Inquiry } from '../types/api';

export function useInquiry(
  options?: Omit<UseMutationOptions<Inquiry, Error, CreateInquiryRequest>, 'mutationFn'>
) {
  return useMutation({
    mutationFn: (data: CreateInquiryRequest) => createInquiry(data),
    ...options,
  });
}
